import React, { useEffect, useState } from "react";
import "./verifyOrder.style.scss";
import worldMap from "../pic/world-map.svg";
import LivePrice from "../livePrice/livePrice";
import { SERVER, SITEURL } from "../../api";
import LivePriceSkeleton from "../livePrice/livePrice.skeleton";
import axios from "axios";

export default function VerifyOrder(props) {
    useEffect(() => {


    }, [])
    return (
        <div>
            {}
        </div>

    )
}


